import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const literatureBooks = [
  { name: "Big Book", url: "/pdfs/GSOSI_BigBook.pdf" },
  { name: "Daily Reflection", url: "/pdfs/GSOSI_Daily_Reflection_out.pdf" },
  { name: "12 வழிமுறைகள், 12 கோட்பாடுகள்", url: "/pdfs/12.pdf" },
];

export default function LiteraturePage() {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen bg-gray-50 py-10 px-4 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-8 text-blue-600 hover:underline text-lg font-medium"
        >
          <ArrowLeft className="w-5 h-5" /> Back
        </button>

        <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          Literature Downloads
        </h1>

        <div className="space-y-4">
          {literatureBooks.map((book, index) => (
            <a
              key={index}
              href={book.url}
              download
              className="block px-6 py-3 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 transition text-center"
            >
              Download {book.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
